import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";
import { lockControlCenter } from "../auth/accessKey";
import "./Sidebar.css";

const Sidebar = ({ isCollapsed, setIsCollapsed, isMobileOpen }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { isDarkMode, toggleTheme } = useTheme();

	const showLabels = !isCollapsed || isMobileOpen;

	const isActive = (path) => {
		if (path === "/workspaces" && (location.pathname === "/" || location.pathname === "/workspaces"))
			return true;
		if (path === "/analytics" && location.pathname === "/analytics")
			return true;
		if (path === "/revenue" && location.pathname === "/revenue")
			return true;
		if (path === "/ai-analyst" && location.pathname === "/ai-analyst")
			return true;
		if (path === "/workspaces" && location.pathname.includes("/workspace/"))
			return true;
		return false;
	};

	const handleNavigation = (path) => {
		navigate(path);
	};

	const toggleSidebar = () => {
		// Button is now non-functional - sidebar always remains collapsed
	};

	return (
		<div className={`sidebar ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "open" : ""}`}>
			{/* Logo/Header */}
			<div className="sidebar-header">
				<div className="logo">
					<div className="logo-icon">⚡</div>
					{showLabels && (
						<div className="logo-text">
							<span className="logo-main">Surge</span>
							<span className="logo-sub">Control Center</span>
						</div>
					)}
				</div>
				<button className="hamburger-toggle" onClick={toggleSidebar}>
					<div
						className={`hamburger-icon ${isCollapsed ? "collapsed" : ""}`}
					>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</button>
			</div>

			{/* Navigation */}
			<nav className="sidebar-nav">
				<div className="nav-section">
					<div
						className={`nav-item ${isActive("/workspaces") ? "active" : ""}`}
						onClick={() => handleNavigation("/workspaces")}
						title={!showLabels ? "Workspaces" : ""}
					>
						<div className="nav-icon">🏢</div>
						{showLabels && (
							<span className="nav-label">Workspaces</span>
						)}
						<div className="nav-indicator"></div>
					</div>
				</div>

				<div className="nav-section">
					<div
						className={`nav-item ${isActive("/analytics") ? "active" : ""}`}
						onClick={() => handleNavigation("/analytics")}
						title={!showLabels ? "Analytics" : ""}
					>
						<div className="nav-icon">📈</div>
						{showLabels && (
							<span className="nav-label">Analytics</span>
						)}
						<div className="nav-indicator"></div>
					</div>
				</div>

				<div className="nav-section">
					<div
						className={`nav-item ${isActive("/revenue") ? "active" : ""}`}
						onClick={() => handleNavigation("/revenue")}
						title={!showLabels ? "Revenue" : ""}
					>
						<div className="nav-icon">💰</div>
						{showLabels && (
							<span className="nav-label">Revenue</span>
						)}
						<div className="nav-indicator"></div>
					</div>
				</div>

				<div className="nav-section">
					<div
						className={`nav-item ${isActive("/ai-analyst") ? "active" : ""}`}
						onClick={() => handleNavigation("/ai-analyst")}
						title={!showLabels ? "AI Analyst" : ""}
					>
						<div className="nav-icon">🤖</div>
						{showLabels && (
							<span className="nav-label">AI Analyst</span>
						)}
						<div className="nav-indicator"></div>
					</div>
				</div>

				{/* Commented out navigation items - these pages are disabled
				<div className="nav-section">
					<div
						className={`nav-item ${isActive("/users") ? "active" : ""}`}
						onClick={() => handleNavigation("/users")}
						title={!showLabels ? "Users" : ""}
					>
						<div className="nav-icon">👥</div>
						{showLabels && (
							<span className="nav-label">Users</span>
						)}
						<div className="nav-indicator"></div>
					</div>
				</div>

				<div className="nav-section">
					<div
						className={`nav-item ${isActive("/workspace-storage") ? "active" : ""}`}
						onClick={() => handleNavigation("/workspace-storage")}
						title={!showLabels ? "Database Storage" : ""}
					>
						<div className="nav-icon">💾</div>
						{showLabels && (
							<span className="nav-label">Database Storage</span>
						)}
						<div className="nav-indicator"></div>
					</div>
				</div>

				<div className="nav-section">
					<div
						className={`nav-item ${isActive("/investor-matrix") ? "active" : ""}`}
						onClick={() => handleNavigation("/investor-matrix")}
						title={!showLabels ? "Investor Matrix" : ""}
					>
						<div className="nav-icon">💼</div>
						{showLabels && (
							<span className="nav-label">Investor Matrix</span>
						)}
						<div className="nav-indicator"></div>
					</div>
				</div>
				*/}
			</nav>

			{/* Footer */}
			<div className="sidebar-footer">
				{/* Theme Toggle */}
				<div className="theme-toggle-container">
					<button 
						className="theme-toggle" 
						onClick={toggleTheme}
						title={!showLabels ? (isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode") : ""}
					>
						<div className="theme-icon">
							{isDarkMode ? "☀️" : "🌙"}
						</div>
						{showLabels && (
							<span className="theme-label">
								{isDarkMode ? "Light Mode" : "Dark Mode"}
							</span>
						)}
					</button>
				</div>

				{/* Lock: forget the access key and return to the key prompt */}
				<div className="theme-toggle-container">
					<button
						className="theme-toggle"
						onClick={lockControlCenter}
						title={!showLabels ? "Lock Control Center" : ""}
					>
						<div className="theme-icon">🔒</div>
						{showLabels && <span className="theme-label">Lock</span>}
					</button>
				</div>

				{showLabels && (
					<div className="version-info">v2.0.1</div>
				)}
			</div>
		</div>
	);
};

export default Sidebar;
